import React from "react";

import { LoadState } from "@/lib/scan-ui/screen";
import { MarketplaceContractsCard } from "@/pages/settings/cards/MarketplaceContractsCard";
import { ReturnsWarehousesCard } from "@/pages/settings/cards/ReturnsWarehousesCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";

/** Настройки возвратов: склады утиля и переупаковки + договоры комиссии
 *  маркетплейсов (их обслуживает обработка возвратов). */
export function ReturnsSettingsPage(): React.ReactElement {
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-4xl space-y-6">
        <SettingsPageHeader
          title="Возвраты"
          subtitle="Склады утиля и переупаковки, договоры комиссии маркетплейсов."
        />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <SettingsPageHeader
        title="Возвраты"
        subtitle="Склады утиля и переупаковки, договоры комиссии маркетплейсов."
      />
      <ReturnsWarehousesCard data={data} />
      <MarketplaceContractsCard />
    </div>
  );
}
